export enum Pagination {
  TAKE = 20,
  START_PAGE = 1,
}
